import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@Organizations/Workspaces/Domain/commands-core'
import { isRef, ref, Ref } from 'vue'
export function useAcceptWorkspaceInvitationCommandV1(id?: string | Ref<string>, recipientEmail?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _recipientEmail = isRef<string>(recipientEmail) ? recipientEmail : ref<string>(recipientEmail)
	const result = {
		id: _id,
		recipientEmail: _recipientEmail,
		...useCommand(() => new c.AcceptWorkspaceInvitationCommandV1(_id.value, _recipientEmail.value))
	}
	return {
		...result,
		invokeAcceptWorkspaceInvitationCommandV1: result.invoke,
		succeedAcceptWorkspaceInvitationCommandV1: result.succeed,
	};
}

export function useAddUserToWorkspaceCommandV1(id?: string | Ref<string>, userId?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _userId = isRef<string>(userId) ? userId : ref<string>(userId)
	const result = {
		id: _id,
		userId: _userId,
		...useCommand(() => new c.AddUserToWorkspaceCommandV1(_id.value, _userId.value))
	}
	return {
		...result,
		invokeAddUserToWorkspaceCommandV1: result.invoke,
		succeedAddUserToWorkspaceCommandV1: result.succeed,
	};
}

export function useCreateWorkspaceCommandV1(id?: string | Ref<string>, organizationUnitId?: number | Ref<number>, name?: string | Ref<string>, description?: string | Ref<string>, startupUrl?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const _name = isRef<string>(name) ? name : ref<string>(name)
	const _description = isRef<string>(description) ? description : ref<string>(description)
	const _startupUrl = isRef<string>(startupUrl) ? startupUrl : ref<string>(startupUrl)
	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		name: _name,
		description: _description,
		startupUrl: _startupUrl,
		...useCommand(() => new c.CreateWorkspaceCommandV1(_id.value, _organizationUnitId.value, _name.value, _description.value, _startupUrl.value))
	}
	return {
		...result,
		invokeCreateWorkspaceCommandV1: result.invoke,
		succeedCreateWorkspaceCommandV1: result.succeed,
	};
}

export function useDeleteWorkspaceCommandV1(id?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const result = {
		id: _id,
		...useCommand(() => new c.DeleteWorkspaceCommandV1(_id.value))
	}
	return {
		...result,
		invokeDeleteWorkspaceCommandV1: result.invoke,
		succeedDeleteWorkspaceCommandV1: result.succeed,
	};
}

export function useImportToWorkspaceCommandV1(id?: string | Ref<string>, blobId?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _blobId = isRef<string>(blobId) ? blobId : ref<string>(blobId)
	const result = {
		id: _id,
		blobId: _blobId,
		...useCommand(() => new c.ImportToWorkspaceCommandV1(_id.value, _blobId.value))
	}
	return {
		...result,
		invokeImportToWorkspaceCommandV1: result.invoke,
		succeedImportToWorkspaceCommandV1: result.succeed,
	};
}

export function useInviteToWorkspaceCommandV1(id?: string | Ref<string>, recipientEmail?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _recipientEmail = isRef<string>(recipientEmail) ? recipientEmail : ref<string>(recipientEmail)
	const result = {
		id: _id,
		recipientEmail: _recipientEmail,
		...useCommand(() => new c.InviteToWorkspaceCommandV1(_id.value, _recipientEmail.value))
	}
	return {
		...result,
		invokeInviteToWorkspaceCommandV1: result.invoke,
		succeedInviteToWorkspaceCommandV1: result.succeed,
	};
}

export function useRejectWorkspaceInvitationCommandV1(id?: string | Ref<string>, recipientEmail?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _recipientEmail = isRef<string>(recipientEmail) ? recipientEmail : ref<string>(recipientEmail)
	const result = {
		id: _id,
		recipientEmail: _recipientEmail,
		...useCommand(() => new c.RejectWorkspaceInvitationCommandV1(_id.value, _recipientEmail.value))
	}
	return {
		...result,
		invokeRejectWorkspaceInvitationCommandV1: result.invoke,
		succeedRejectWorkspaceInvitationCommandV1: result.succeed,
	};
}

export function useRemoveUserFromWorkspaceCommandV1(id?: string | Ref<string>, userId?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _userId = isRef<string>(userId) ? userId : ref<string>(userId)
	const result = {
		id: _id,
		userId: _userId,
		...useCommand(() => new c.RemoveUserFromWorkspaceCommandV1(_id.value, _userId.value))
	}
	return {
		...result,
		invokeRemoveUserFromWorkspaceCommandV1: result.invoke,
		succeedRemoveUserFromWorkspaceCommandV1: result.succeed,
	};
}

export function useUpdateWorkspaceCommandV1(id?: string | Ref<string>, name?: string | Ref<string>, description?: string | Ref<string>, startupUrl?: string | Ref<string>, ) {
	const _id = isRef<string>(id) ? id : ref<string>(id)
	const _name = isRef<string>(name) ? name : ref<string>(name)
	const _description = isRef<string>(description) ? description : ref<string>(description)
	const _startupUrl = isRef<string>(startupUrl) ? startupUrl : ref<string>(startupUrl)
	const result = {
		id: _id,
		name: _name,
		description: _description,
		startupUrl: _startupUrl,
		...useCommand(() => new c.UpdateWorkspaceCommandV1(_id.value, _name.value, _description.value, _startupUrl.value))
	}
	return {
		...result,
		invokeUpdateWorkspaceCommandV1: result.invoke,
		succeedUpdateWorkspaceCommandV1: result.succeed,
	};
}

